import CryptoJS from "crypto-js";


function processKey2(key) {
    let length = key.length;

    // 确定目标长度（AES标准密钥长度）
    if (length <= 16) {
        length = 16;
    } else if (length <= 24) {
        length = 24;
    } else {
        length = 32;
    }

    // 计算需要重复拼接的次数（取整数部分）
    const repeatTimes = Math.floor(length / key.length);

    // 构建重复字符串
    let sb = key;
    for (let i = 0; i < repeatTimes; i++) {
        sb += key;
    }

    // 截取目标长度（可能截断中间部分）
    return sb.substring(0, length);
}


export default {
    //加密
    encrypt(content, key) {
        const key222 = processKey2(key)
        
        try {
            const keyBytes = CryptoJS.enc.Utf8.parse(key222);
            const iv = CryptoJS.enc.Utf8.parse(''); // ECB模式不需要IV

            const encrypted = CryptoJS.AES.encrypt(content, keyBytes, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            });

            return encrypted;
        } catch (e) {
            throw new Error('Encrypt error: ' + e.message);
        }
    },
    //解密
    decrypt(content, key) {
        const key222 = processKey2(key)
        // 获取加密结果的文本内容
        const encryptedText = content;

        try {
            const keyBytes = CryptoJS.enc.Utf8.parse(key222);
            const iv = CryptoJS.enc.Utf8.parse(''); // ECB模式不需要IV

            const decrypted = CryptoJS.AES.decrypt(encryptedText, keyBytes, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            });

            const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);

            return decryptedText;
        } catch (e) {
            throw new Error('Encrypt error: ' + e.message);
        }
    },
};


